import React from "react";

import ApplicationPanelForm from "components/ApplicationPanel";

const ApplicationPanel = () => {
  return <ApplicationPanelForm />;
};

export default ApplicationPanel;
